import router from "@/router";
import i18n from "@/i18n/i18n";
import {
  ChatBot,
  ChatBotRoom,
  ChatBotMessage,
  GetChatGPTBasicSetting,
  GetChaBotDecisionTree,
  ChatBotSurveyCode,
  SN_Block_Setting,
} from "@/api/gpt";
import { SettingMetas } from "@/api/settingMetas";
import { getRandom } from "@/plugins/getRandom";
const botRender = JSON.parse(sessionStorage.getItem("asus_chat_gpt_botrender"));
const state = {
  loading: false,
  params: JSON.parse(localStorage.getItem("asus_chat_gpt_create")) || null,
  setting: { ChatGPT_NonService: "" },
  beforeChat: null,
  tree: null,
  surveyCode: [],
  botRoom: {
    chatBotRoomId: "",
    sessionId: "",
    messages: [],
    isFinished: true,
    countryId: "",
    isServiceTime: false,
    isSingleServiceTime: false,
  },
  botRender: botRender || {
    chatBotRoomId: "",
    sessionId: "",
    bot: "Technical Support",
    BotScope: "", // 目前充當是否顯示footer的參數
    userInput: "",
    chatType: "",
    chatType2: "",
  },
  userInputs: [],
  liveSupportCounts: 0, //觸發轉真人
  unlikeCounts: 0,
  idleTime: 0,
  offlineTime: 0,
};

const actions = {
  async createRoom({ state, commit }) {
    localStorage.setItem("asus_chat_gpt_create", JSON.stringify(state.params));
    commit("reset"); // AP-2819 清除上一個 room 的相關資訊
    try {
      const res = await ChatBotRoom.Create(state.params);
      // 清除上次紀錄的是否 typing 的 message id
      localStorage.removeItem("asus_chat_gpt_typed");

      // 存下sessionId , 前往 room
      // sessionStorage 用來偵測是否關閉視窗回來
      sessionStorage.setItem(
        "asus_chat_webSiteCountry",
        state.params.asusWebSiteCountry
      );
      sessionStorage.setItem("asus_chat_gpt_sessionid", res.data.sessionId);

      commit("setBotRoom", res.data);
      router.push(`/gpt/${res.data.chatBotRoomId}`);
    } catch (error) {
      console.log("catch", error);
    }
  },
  async createNewRoom({ state, commit, dispatch }) {
    // 關閉當前 room
    const { chatBotRoomId, sessionId } = state.botRoom;
    await ChatBotRoom.Leave({ chatBotRoomId, sessionId });

    // 建立新 room
    const params = JSON.parse(localStorage.getItem("asus_chat_gpt_create"));
    const countryId = state.botRoom.countryId;

    if (params) {
      dispatch("createRoom");
    } else {
      router.push(`/gpt?country=${countryId}`);
    }
  },
  async leaveRoom({ commit }, payload) {
    await ChatBotRoom.Leave(payload);
    localStorage.removeItem("asus_chat_gpt_sessionid");
    commit("finishRoom", payload.chatBotRoomId);
  },
  // 取得文案與決策樹資料
  async initSettingMetas({ state, dispatch, commit }, payload) {
    // console.log("initSettingMetas", payload);
    try {
      const basic = await GetChatGPTBasicSetting.get(payload);
      const beforeChat = await SettingMetas.GetBeforeChat(payload);
      const tree = await GetChaBotDecisionTree.get(payload);
      const surveyCode = await ChatBotSurveyCode.List({
        countryId: payload,
        isSatisfied: false,
      });
      commit("setMetas", {
        setting: basic.data.settings,
        tree: tree.data.items,
        surveyCode: surveyCode.data,
        beforeChat: beforeChat.data,
      });
      if (
        state.botRoom.isFinished === false &&
        state.botRoom.messages.length === 0
      ) {
        dispatch("createWelcomeMessage");
      }
    } catch (error) {
      console.log("error", error);
    }
  },
  async createWelcomeMessage({ state, dispatch, getters }, payload = false) {
    //payload = GUI測試用
    if (payload || state.botRoom.messages.length === 0) {
      // 歡迎訊息 和 初始服務選單
      await dispatch("createBotReplyMessage", "ChatGPT_Welcome");
      await dispatch("createOptionMessage");
      window.dataLayer.push({
        event: "data_layer_event",
        chatbot_session_id: getters.chatbot_session_id,
        event_name_ga4: "window_impression_genio",
        event_category_DL: "genio",
        event_action_DL: "displayed",
        event_label_DL: "window_impression/genio",
      });
    }
  },
  // 送出服務選單
  createOptionMessage({ dispatch, getters }, payload) {
    // payload = 選單項目 或 預設getters.lv1
    let content = payload || getters.lv1;
    const data = {
      type: "Option",
      chatUserRole: "System",
      content: JSON.stringify(content),
    };
    // console.log("data", data);
    return dispatch("createMessage", data);
  },
  // 轉真人訊息
  createToAgentMessage({ state, dispatch }, payload) {
    // console.log("轉真人訊息 createToAgentMessage");
    // payload :
    // "ChatGPT_ToAgent_TerminationService" (觸發轉真人)
    // "ChatGPT_ChatSentences_TerminationService" (對話次數限制)
    const reply = state.setting[payload] || "Not set.";
    const data = {
      type: "ToAgent",
      chatUserRole: "System",
      content: reply,
    };
    dispatch("createMessage", data);
  },
  createSettingMessage({ state, dispatch }, payload) {
    const message = state.setting[payload];
    const data = {
      type: "System",
      chatUserRole: "System",
      content: message,
    };
    dispatch("createMessage", data);
  },
  createBotReplyMessage({ state, dispatch }, payload) {
    // 多個replys隨機挑選
    let replys;
    let reply;
    if (state.setting[payload]) {
      replys = JSON.parse(state.setting[payload]);
      reply = replys.length
        ? replys[getRandom(0, replys.length - 1)]
        : "Not set.";
    } else {
      reply = "Not set.";
    }

    const data = {
      type: "System",
      chatUserRole: "System",
      content: reply,
    };
    // console.log(payload, ":", data);
    return dispatch("createMessage", data);
  },
  createBotSettingMessage({ state, dispatch }, payload) {
    const data = {
      type: "System",
      chatUserRole: "System",
      content: state.setting[payload] || "Not set.",
    };
    return dispatch("createMessage", data);
  },
  // 維修查詢失敗訊息(AP-4327)
  createBotSettingRepairFailMessage({ state, commit, dispatch }, payload) {
    commit("cleanBotRenderChatType");
    const data = {
      type: "System_Repair",
      chatUserRole: "System",
      content: state.setting[payload] || "Not set.",
    };
    return dispatch("createMessage", data);
  },
  // 保固查詢失敗訊息(AP-4327)
  createBotSettingWarrantyFailMessage({ state, commit, dispatch }, payload) {
    commit("cleanBotRenderChatType");
    const data = {
      type: "System_Warranty",
      chatUserRole: "System",
      content: state.setting[payload] || "Not set.",
    };
    return dispatch("createMessage", data);
  },
  createMessage({ state, commit, getters }, payload) {
    const { type, content, chatUserRole, isHint = false } = payload;
    const params = {
      chatBotRoomId: state.botRoom.chatBotRoomId,
      sessionId: state.botRoom.sessionId,
      type,
      content,
      chatUserRole,
      isHint,
    };
    commit("setIdleTime", "off"); // reset idleTime
    return new Promise((resolve, reject) => {
      ChatBotMessage.Create(params)
        .then((res) => {
          // GA4 顯示轉接真人
          if (type === "ToAgent") {
            window.dataLayer.push({
              event: "data_layer_event",
              chatbot_session_id: getters.chatbot_session_id,
              event_name_ga4: "to_agent_impression_genio",
              event_category_DL: "genio",
              event_action_DL: "displayed",
              event_label_DL: "to_agent_impression/genio",
            });
          }
          // 顯示連結按鈕
          if (type === "OptionSelect" && chatUserRole === "System") {
            const buttonText = JSON.parse(content).buttonText || "";
            window.dataLayer.push({
              event: "data_layer_event",
              chatbot_session_id: getters.chatbot_session_id,
              event_name_ga4: "link_impression_genio",
              event_category_DL: "genio",
              event_action_DL: "displayed",
              event_label_DL: `${buttonText}/link_impression/genio`,
            });
          }

          commit("pushMessage", res.data);
          resolve(res);
        })
        .catch((error) => {
          console.log("catch", error);
          reject(error);
        })
        .finally(() => {});
    });
  },
  async createChatRenderMessage({ state, commit, dispatch, getters }) {
    // console.log("createChatRenderMessage BotScope:", state.botRender.BotScope);
    if (!state.userInputs.length) {
      return;
    }

    // AP-6473 無 botscope 直接轉真人
    if (!state.botRender.BotScope) {
      // console.log("AP-6473 無 botscope 直接轉真人");
      dispatch("createToAgentMessage", "ChatGPT_ToAgent_TerminationService");
      return;
    }

    commit("setBotRender", {
      userInput: state.userInputs.toString().replaceAll(",", ""),
    });

    const RepairLimit = state.setting.ChatGPT_Repair_NoSn_ErrorTimes;
    const WarrantyLimit = state.setting.ChatGPT_Warranty_NoSn_ErrorTimes;
    const { chatType, chatType2 } = state.botRender; // 當前的chatType

    // AP-8470 SN Check機制追加條件 (黑名單)
    if ((await dispatch("checkSN")) === true) {
      commit("toggleLoading", true);
      try {
        const res = await ChatBot.ChatRenderV2(state.botRender);
        const { Status, Result } = JSON.parse(res.data.content);

        const KbList = Result ? Result.KbList : [];
        const ReturnChatType = Result ? Result.ReturnChatType : "";
        const ReturnChatType2 = Result ? Result.ReturnChatType2 : "";

        const getReturnMessage = () => {
          try {
            return JSON.parse(Result.ReturnMessage);
          } catch (e) {
            return { message: Result ? Result.ReturnMessage : "" };
          }
        };
        let ReturnMessage = getReturnMessage();

        // console.log(Status, Result, ReturnMessage);

        // [KB1.0]
        if (KbList.length) {
          console.log("[KB 1.0]SUCCESS回覆");
          // GA4 顯示 讚與倒讚時
          window.dataLayer.push({
            event: "data_layer_event",
            chatbot_session_id: getters.chatbot_session_id,
            event_name_ga4: "like_impression_genio",
            event_category_DL: "genio",
            event_action_DL: "displayed",
            event_label_DL: "like_impression/genio",
          });
        }
        //
        //
        // [KB2.0]
        else if ("ragResponse" in ReturnMessage) {
          if (ReturnMessage.status === "SUCCESS") {
            // V2.0 SUCCESS
            console.log("[KB 2.0]SUCCESS回覆");
            // GA4 顯示 讚與倒讚時
            window.dataLayer.push({
              event: "data_layer_event",
              chatbot_session_id: getters.chatbot_session_id,
              event_name_ga4: "like_impression_genio",
              event_category_DL: "genio",
              event_action_DL: "displayed",
              event_label_DL: "like_impression/genio",
            });
          } else {
            // V2.0 FAIL
            console.log("[KB 2.0]FAIL回覆");
            dispatch(
              "createToAgentMessage",
              "ChatGPT_ToAgent_TerminationService"
            );
          }
        }
        //
        //
        // [維修]查詢功能
        else if (
          ReturnChatType === "Repair Service" &&
          ReturnChatType2 === "inquire-repair-status" &&
          "repairStatus" in ReturnMessage
        ) {
          if (
            chatType !== "Repair Service" &&
            chatType2 !== "inquire-repair-status"
          ) {
            console.log("首次進入[維修]查詢功能");
            // 1. 請輸入序號的提示訊息
            dispatch("createBotSettingMessage", "ChatGPT_Repair_SnNo_Input");
            // 2. 存下意圖
            commit("setChatType", {
              chatType: ReturnChatType,
              chatType2: ReturnChatType2,
            });
          } else if (ReturnMessage.status === "SUCCESS") {
            // 維修查詢SUCCESS
            commit("cleanBotRenderChatType", false);
          } else if (ReturnMessage.status === "FAIL") {
            await dispatch(
              "createBotSettingRepairFailMessage",
              "ChatGPT_Repair_NoSn"
            );
          } else {
            // 維修查詢FAIL

            if (ReturnMessage.failCount >= RepairLimit) {
              // 1. 超過失敗次數，轉接客服提示
              if (
                !state.botRoom.isServiceTime &&
                state.botRoom.isSingleServiceTime
              ) {
                // 為單一服務時間 + 非服務時務時間時 = 一般轉真人
                dispatch(
                  "createToAgentMessage",
                  "ChatGPT_ToAgent_TerminationService"
                );
              } else {
                dispatch(
                  "createToAgentMessage",
                  "ChatGPT_Repair_NoSn_TransferToAgent"
                );
              }
            } else {
              // AP-4372 清除查詢維修的意圖，顯示重新查詢按鈕
              await dispatch(
                "createBotSettingRepairFailMessage",
                "ChatGPT_Repair_NoSn"
              );
            }
            commit("cleanBotRenderChatType");
          }
        }
        //
        //
        // [保固]查詢功能
        else if (
          ReturnChatType === "Warranty and Policy" &&
          ReturnChatType2 === "inquire-product-warranty-period" &&
          "snStatus" in ReturnMessage
        ) {
          if (
            chatType !== "Warranty and Policy" &&
            chatType2 !== "inquire-product-warranty-period"
          ) {
            console.log("首次進入[保固]查詢功能");
            // 1. 請輸入序號的提示訊息
            dispatch("createBotSettingMessage", "ChatGPT_Warranty_SnNo_Input");
            // 2.存下意圖
            commit("setChatType", {
              chatType: ReturnChatType,
              chatType2: ReturnChatType2,
            });
          } else if (ReturnMessage.status === "SUCCESS") {
            // 保固查詢SUCCESS
            // 查詢成功清除意圖
            commit("cleanBotRenderChatType", false);
          } else if (ReturnMessage.status === "FAIL") {
            await dispatch(
              "createBotSettingWarrantyFailMessage",
              "ChatGPT_Warranty_NoSn"
            );
          } else {
            // 保固查詢FAIL
            if (ReturnMessage.failCount >= WarrantyLimit) {
              // 1. 超過失敗次數，轉接客服提示
              if (
                !state.botRoom.isServiceTime &&
                state.botRoom.isSingleServiceTime
              ) {
                // 為單一服務時間 + 非服務時務時間時 = 一般轉真人
                dispatch(
                  "createToAgentMessage",
                  "ChatGPT_ToAgent_TerminationService"
                );
              } else {
                dispatch(
                  "createToAgentMessage",
                  "ChatGPT_Warranty_NoSn_TransferToAgent"
                );
              }
            } else {
              // await dispatch("createBotSettingMessage", "ChatGPT_Warranty_NoSn");
              // AP-4372 清除查詢維修的意圖，顯示重新查詢按鈕

              await dispatch(
                "createBotSettingWarrantyFailMessage",
                "ChatGPT_Warranty_NoSn"
              );
            }
            commit("cleanBotRenderChatType");
          }
        }
        // 非服務時間+單一服務時
        // else if (
        //   !state.botRoom.isServiceTime &&
        //   state.botRoom.isSingleServiceTime
        // ) {
        //   dispatch("handleNonService", state.botRender.id);
        // }
        else if (ReturnChatType2 || ReturnChatType) {
          // 一般自訂意圖功能
          // 偵測到第二層意圖
          // console.log("進入雙層決策樹");
          const result2 = await dispatch(
            "handleReturnMessage",
            ReturnChatType2
          );
          if (result2 === false) {
            // 往回尋求第一層
            const result1 = await dispatch(
              "handleReturnMessage",
              ReturnChatType
            );
            if (result1 === false) {
              dispatch(
                "createToAgentMessage",
                "ChatGPT_ToAgent_TerminationService"
              );
            }
          }
        } else {
          dispatch(
            "createToAgentMessage",
            "ChatGPT_ToAgent_TerminationService"
          ); // 後台設定的轉接真人回覆
        }

        commit("pushMessage", res.data);
        commit("saveUserInput"); // clean userInputs
      } catch (error) {
        console.log("catch", error);
      }
      commit("toggleLoading", false);
    }
  },
  handleReturnMessage({ state, dispatch }, botKeyName) {
    // 偵測到意圖  ReturnMessage = botKeyName
    // 透過 botKeyName 找到對應的決策樹資料(editData)
    let target;

    const find = (items) => {
      if (!items.length) return;
      items.forEach((el) => {
        if (el.editData.botKeyName === botKeyName) {
          target = el;
        } else {
          find(el.items);
        }
      });
    };

    find(state.tree[0].items);

    if (target) {
      const {
        isToAgent,
        layout,
        desc,
        toAgentDesc,
        isToAgentNonService,
        toAgentNonServiceDesc,
        chatGPTUrl,
        id,
      } = target.editData;

      if (isToAgent) {
        // console.log('這個意圖有設定為 isToAgent');
        // dispatch("createToAgentMessage", "ChatGPT_ToAgent_TerminationService");
        let data = { chatUserRole: "System", type: "", content: "" };
        if (
          !state.botRoom.isServiceTime &&
          state.botRoom.isSingleServiceTime &&
          isToAgentNonService
        ) {
          // 沒營業
          // 項目有指定非服務時間回覆的文案
          data.type = "NonService";
          data.content = toAgentNonServiceDesc;
        } else {
          // 有營業的轉真人 or 沒營業轉真人(會有固定非營業的文案)
          data.type = "ToAgent";
          data.content = toAgentDesc;
        }
        dispatch("createMessage", data);
      } else if (target.items.length) {
        // 意圖有子層
        const data = {
          parentLayout: layout,
          desc: desc,
          data: target.items,
        };
        dispatch("createOptionMessage", data);
      } else if (chatGPTUrl) {
        dispatch("setBotRender", { BotScope: chatGPTUrl, id: id });
        dispatch("createBotReplyMessage", "ChatGPT_Welcome");
      } else {
        // 意圖本身
        const data = {
          type: "OptionSelect",
          chatUserRole: "System",
          content: JSON.stringify(target.editData),
        };
        dispatch("createMessage", data);
      }
    } else {
      // 意圖與tree對不上時
      // console.log(`Decision tree 找不到 ${ReturnMessage} 的資料`);
      // dispatch("createToAgentMessage", "ChatGPT_ToAgent_TerminationService");
      return false;
    }
  },
  handleChatLike(
    { state, dispatch, commit },
    { chatBotMessageId, likeFlag, surveyCode }
  ) {
    const params = {
      chatBotRoomId: state.botRoom.chatBotRoomId,
      sessionId: state.botRoom.sessionId,
      chatBotMessageId,
      likeFlag,
      surveyCode,
    };
    return new Promise((resolve, reject) => {
      ChatBot.ChatLike(params)
        .then((res) => {
          const result = {
            id: res.data.id,
            isLike: res.data.isLike,
          };
          commit("likeMessage", result);
          dispatch("checkUnlikeCounts");
          resolve(res);
        })
        .catch((error) => {
          console.log("catch", error);
          reject(error);
        });
    });
  },
  checkUnlikeCounts({ state, dispatch }) {
    const counts = parseInt(state.setting.ChatGPT_Satisfaction);
    const unlikeCounts = state.unlikeCounts;
    // console.log(`檢查不滿意次數：${unlikeCounts}/${counts}`);
    if (unlikeCounts >= counts) {
      // AP-1586 後台文案的輸入框拿掉，只出現 詢問是否轉真人的對話，即可
      // dispatch(
      //   "createSettingMessage",
      //   "ChatGPT_Satisfaction_TerminationService"
      // );
      dispatch("createToAgentMessage", "ChatGPT_ToAgent_TerminationService");
    }
  },
  async closeRoom({ state, commit, dispatch }, payload = true) {
    // payload = 是否顯示結束對話訊息
    const { chatBotRoomId, sessionId } = state.botRoom;
    try {
      await ChatBotRoom.Leave({ chatBotRoomId, sessionId });
      if (payload) {
        dispatch("createBotReplyMessage", "ChatGPT_LeaveRoom");
      }
      commit("finishRoom", chatBotRoomId);
    } catch (error) {
      console.log("catch", error);
    }
  },
  // handleToLiveSupport({ state, dispatch, commit }) {
  //   // 觸發轉真人意圖計次
  //   commit("setLiveSupportCounts");

  //   const counts = state.setting.ChatGPT_ToAgent;
  //   const liveSupportCounts = state.liveSupportCounts;
  //   console.log(`檢查觸發轉真人次數：${liveSupportCounts}/${counts}`);
  //   if (liveSupportCounts >= counts) {
  //     dispatch("createToAgentMessage", "ChatGPT_ToAgent_TerminationService");
  //     dispatch("createOptionMessage");
  //   }
  // },
  transferToAgent({ state, dispatch }) {
    dispatch("closeRoom");
    const { countryId, chatBotRoomId } = state.botRoom;
    const { device, platform } = JSON.parse(
      localStorage.getItem("asus_chat_gpt_create")
    );
    router.push(
      `/?country=${countryId}&skipPolicy=1&chatBotRoomId=${chatBotRoomId}&platform=${platform}&device=${device}`
    );
  },

  async checkSN({ state, commit, dispatch }) {
    const { userInput, BotScope, chatType, chatType2 } = state.botRender; // 當前的chatType

    if (BotScope === "warranty" || BotScope === "repair") {
      try {
        const res = await SN_Block_Setting.CheckSN({
          RegionId: state.botRoom.countryId,
          SN: userInput,
        });
        if (res.data.isComponentSn) {
          const data = {
            type: "System",
            chatUserRole: "System",
            content: i18n.t("GPT.IS_COMPONENT_SN"),
          };
          await dispatch("createMessage", data);

          if (
            chatType == "Repair Service" &&
            chatType2 == "inquire-repair-status"
          ) {
            await dispatch(
              "createBotSettingRepairFailMessage",
              "ChatGPT_Repair_NoSn"
            );
          } else if (
            chatType == "Warranty and Policy" &&
            chatType2 == "inquire-product-warranty-period"
          ) {
            await dispatch(
              "createBotSettingWarrantyFailMessage",
              "ChatGPT_Warranty_NoSn"
            );
          }

          return false;
        } else {
          return true; // pass 不是黑名單
        }
      } catch (error) {
        console.log("catch", error);
        return true; // pass 不是黑名單
      }
    } else {
      return true; // pass 不用檢查
    }
  },
};

const mutations = {
  reset(state) {
    state.botRender = {
      chatBotRoomId: "",
      sessionId: "",
      bot: "Technical Support",
      BotScope: "",
      userInput: "",
      chatType: "",
      chatType2: "",
    };
    sessionStorage.removeItem("asus_chat_gpt_botrender");
  },
  toggleLoading(state, payload) {
    state.loading = payload;
    if (payload === false) {
      state.botRoom.messages.forEach((m, index) => {
        if (m.id === "loading") {
          state.botRoom.messages.splice(index, 1);
        }
      });
    }
  },
  setCreateParams(state, payload) {
    localStorage.setItem("asus_chat_gpt_create", JSON.stringify(payload));
    sessionStorage.setItem(
      "asus_chat_webSiteCountry",
      payload.asusWebSiteCountry
    );
    state.params = payload;
  },
  setMetas(state, payload) {
    state.setting = payload.setting;
    state.tree = payload.tree;
    state.surveyCode = payload.surveyCode;
    state.beforeChat = payload.beforeChat;
  },
  setBotRoom(state, payload) {
    state.botRoom = payload;
  },
  pushMessage(state, payload) {
    state.botRoom.messages.push(payload);
  },
  likeMessage(state, payload) {
    const { id, isLike } = payload;
    state.botRoom.messages.forEach((m) => {
      if (m.id === id) {
        m.isLike = isLike;
      }
    });

    let unlikes = state.botRoom.messages.filter((el) => el.isLike === false);
    state.unlikeCounts = unlikes.length;
  },
  setBotRender(state, payload) {
    // state.botRender.chatType = chatType;
    // state.botRender.chatType2 = chatType2;
    // state.botRender.chatBotRoomId = state.botRoom.chatBotRoomId;
    // state.botRender.sessionId = state.botRoom.sessionId;
    // state.botRender.bot = bot;
    // state.botRender.BotScope = BotScope;
    // state.botRender.userInput = userInput;
    state.botRender.chatBotRoomId = state.botRoom.chatBotRoomId;
    state.botRender.sessionId = state.botRoom.sessionId;
    Object.assign(state.botRender, payload);
    sessionStorage.setItem(
      "asus_chat_gpt_botrender",
      JSON.stringify(state.botRender)
    );
  },
  cleanBotRenderChatType(state, cleanBotScope = true) {
    state.botRender.BotScope = cleanBotScope ? "" : state.botRender.BotScope;
    state.botRender.userInput = "";
    state.botRender.chatType = "";
    state.botRender.chatType2 = "";

    state.userInputs = []; // clean userInputs
    sessionStorage.setItem(
      "asus_chat_gpt_botrender",
      JSON.stringify(state.botRender)
    );
  },
  cleanBotScope() {
    state.botRender.BotScope = "";
    sessionStorage.setItem(
      "asus_chat_gpt_botrender",
      JSON.stringify(state.botRender)
    );
  },
  setChatType(state, payload) {
    state.botRender.chatType = payload.chatType;
    state.botRender.chatType2 = payload.chatType2;
    sessionStorage.setItem(
      "asus_chat_gpt_botrender",
      JSON.stringify(state.botRender)
    );
  },
  setLiveSupportCounts(state, payload = true) {
    if (payload) {
      state.liveSupportCounts++;
    } else {
      state.liveSupportCounts = 0;
    }
  },
  saveUserInput(state, payload) {
    if (payload) {
      state.userInputs.push(payload);
    } else {
      state.userInputs = [];
    }
  },
  // times
  setIdleTime(state, payload) {
    if (payload == "on") {
      state.idleTime++;
    } else {
      state.idleTime = 0;
    }
  },
  finishRoom(state) {
    state.botRoom.isFinished = true;
  },
};

const getters = {
  // 第一層 Service Type
  lv1: (state) => {
    if (state.tree) {
      const parentLayout = state.tree[0].editData.layout;
      const desc = state.tree[0].editData.desc;
      const arr = state.tree[0].items.map((el) => {
        return el;
      });
      return {
        parentLayout,
        desc,
        data: arr,
      };
    } else {
      return {};
    }
  },
  // 第二層(Technical Support)選項 skills
  lv2: (state) => {
    if (state.tree) {
      const target = state.tree[0].items.find((item) => {
        return item.editData.botKeyName === "Technical Support";
      });
      const arr = target.items.map((el) => {
        return el.editData;
      });
      const parentLayout = target.editData.layout;
      return {
        parentLayout,
        data: arr,
      };
    } else {
      return {};
    }
  },
  answerCounts: (state) => {
    const messages = state.botRoom.messages.filter(
      (el) => el.chatUserRole === "ChatBot"
    );
    const success = messages.filter((el) => {
      const { Status, Result } = JSON.parse(el.content);
      // return Status === 200 && Result.KbList.length;
      return Status === 200;
    });
    return {
      fail: messages.length - success.length,
      success: success.length,
      total: messages.length,
    };
  },
  botStart: (state) => {
    const { BotScope } = state.botRender;
    return BotScope ? true : false;
  },
  chatbot_session_id: (state) => {
    const roomId = state.botRoom.chatBotRoomId;
    if (roomId) {
      return `${
        process.env.VUE_APP_PRO_ENV
      }_${new Date().getFullYear()}_${roomId}`;
    } else {
      return "";
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
